import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCardSettingsContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CardSettingsContainer" */
                '@perpay-web/fintech/components/containers/CardSettingsContainer'
            ),
    );
